



































































    import {Component, Vue, Inject} from 'vue-property-decorator';
    import TenantSwitch from '../components/tenant-switch.vue'
    import AbpBase from '../lib/abpbase'
    import {GetUserInfoByUserName,GetCurrentUserRoleId} from "@/api/account"
	import axios from 'axios'

    @Component({
        components: {TenantSwitch}
    })
    export default class Login extends AbpBase {
        //
        roles = []
        showWrap: Boolean = false
        loginModel = {
            userNameOrEmailAddress: '',
            roleId:null,
            password: '',
            rememberMe: false
        }
        showChangeTenant: boolean = false

        async login() {
            (this.$refs.loginForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'app/login',
                        data: this.loginModel
                    })
                    sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '0');
                    location.reload();
                }
            });
        }

        userName: string = ''

        getHosp() {
            this.userName = '张益达'
        }
        async getUserInfo(){
            let res = await GetUserInfoByUserName({userName: this.loginModel.userNameOrEmailAddress})
            if (res.code === 2000) {
                this.userName = res.data && res.data.name || ''
                this.getRoles(res.data.id)
            } else {
                this.userName = ''
            }
        }
        async getRoles(id){
            let res = await GetCurrentUserRoleId({id:id})
            this.roles = res.data
            if(res.data.length >= 1){
                setTimeout(()=>{
                    this.loginModel.roleId = this.roles[0].key
                },10)
            }
        }
        rules = {
            userNameOrEmailAddress: [
                {required: true, message: "请输入用户名！", trigger: 'blur'}
            ],
            password: [
                {required: true, message: "请输入密码！", trigger: 'blur'}
            ],
            roleId: [
                {required: true, message: "请选择角色！", trigger: 'blur'}
            ]
        }

        created() {
            const currentLanguage = abp.utils.getCookieValue("Abp.Localization.CultureName")
            if (currentLanguage !== "zh-Hans") {
                abp.utils.setCookieValue(
                    "Abp.Localization.CultureName",
                    "zh-Hans",
                    new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
                    abp.appPath
                );
                // setTimeout(location.reload(),2000)
                location.reload();
            }
        }
    }
